import VehicleFaultActionsPanel from './VehicleFaultActionsPanel';

export default VehicleFaultActionsPanel;
